import React from 'react';
import AdminLoginForm from '../components/AdminLoginForm';
import { Container, Typography, Box } from '@mui/material';

const AdminLoginPage = () => {
    return (
        <Container maxWidth='sm'>
            <Box sx={{ mt: 10, textAlign: 'center' }}>
                <Typography variant='h4' gutterBottom>
                    Admin Portal Login
                </Typography>
                <AdminLoginForm />
            </Box>
        </Container>
    );
};


export default AdminLoginPage;